import React from "react";
import styled from "styled-components";
import { useState } from "react";





    const WalletContainer = styled.div`
        background: #fff;
        border-radius: 12px;
      width:100%;
        padding: 32px;
    
        display:flex;
        flex-direction:column;
        justify-content:flex-start;
        align-items:flex-start;


        h2{
         font-size:1rem;
         margin-bottom:1rem;
         font-weight:400;
        }

          h3{
         font-size:1rem;
         margin-bottom:1rem;
         font-weight:400;
         text-align:left;
        }
    `;

    const Balance = styled.div`
        font-size: 1rem;
        font-weight: 400;
        margin-bottom: 12px;
    `;

    const WithdrawSection = styled.div`
        margin-top: 24px;
    `;

    const OptionTabs = styled.div`
        display: flex;
        gap: 16px;
        margin-bottom: 16px;
    `;

    const Tab = styled.button`
        background: ${props => props.active ? "#999" : "#f0f0f0"};
        color: ${props => props.active ? "#fff" : "#333"};
        border: none;
        border-radius: 6px;
        padding: 8px 16px;
        cursor: pointer;
    `;

    const Input = styled.input`
        width: 100%;
        padding: 8px;
        margin-bottom: 12px;
        border: 1px solid #ccc;
        border-radius: 6px;
    `;

    const WithdrawButton = styled.button`
        background:rgb(243, 147, 51);
        color: #fff;
        border: none;
        border-radius: 3px;
        padding: 10px 20px;
        font-size: 1rem;
        cursor: pointer;
        margin-right:auto;
    `;

    export default function Wallet() {
        const [balance] = useState(" 0"); // Example balance
        const [withdrawMethod, setWithdrawMethod] = useState("account");
        const [amount, setAmount] = useState("");
        const [accountDetails, setAccountDetails] = useState({ accountNumber: "", ifsc: "" });
        const [upiId, setUpiId] = useState("");

        const handleWithdraw = () => {
            // Add withdraw logic here
            alert("Withdrawal request submitted!");
        };

        return (
            <WalletContainer>
                <h2>My Wallet</h2>
                <Balance>₹{balance.toLocaleString()}</Balance>
                <WithdrawSection>
                    <h3>Withdraw Money</h3>
                    <OptionTabs>
                        <Tab
                            active={withdrawMethod === "account"}
                            onClick={() => setWithdrawMethod("account")}
                        >
                            Account Details
                        </Tab>
                        <Tab
                            active={withdrawMethod === "upi"}
                            onClick={() => setWithdrawMethod("upi")}
                        >
                            UPI ID
                        </Tab>
                    </OptionTabs>
                    <Input
                        type="number"
                        placeholder="Amount"
                        value={amount}
                        onChange={e => setAmount(e.target.value)}
                    />
                    {withdrawMethod === "account" ? (
                        <>
                            <Input
                                type="text"
                                placeholder="Account Number"
                                value={accountDetails.accountNumber}
                                onChange={e => setAccountDetails({ ...accountDetails, accountNumber: e.target.value })}
                            />
                            <Input
                                type="text"
                                placeholder="IFSC Code"
                                value={accountDetails.ifsc}
                                onChange={e => setAccountDetails({ ...accountDetails, ifsc: e.target.value })}
                            />
                        </>
                    ) : (
                        <Input
                            type="text"
                            placeholder="UPI ID"
                            value={upiId}
                            onChange={e => setUpiId(e.target.value)}
                        />
                    )}
                   <div style={{display:'flex',justifyContent:'flex-start',width:'100%'}}>
                     <WithdrawButton onClick={handleWithdraw}>Withdraw</WithdrawButton>
                   </div>
                </WithdrawSection>
            </WalletContainer>
        );
    }
